import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import { connect } from 'react-redux';

import AutoRelatedQuery from 'Query/AutoRelated.query';
import { fetchQuery } from 'Util/Request';

import AutoRelatedSlider from './AutoRelatedSlider.component';

/** @namespace Advox/Component/AutoRelatedSlider/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    productUrlSuffix: state.ConfigReducer.product_url_suffix,
});

/** @namespace Advox/Component/AutoRelatedSlider/Container/mapDispatchToProps */
export const mapDispatchToProps = () => ({});

/** @namespace Advox/Component/AutoRelatedSlider/Container */
export class AutoRelatedSliderContainer extends PureComponent {
    static propTypes = {
        type: PropTypes.oneOf(['mpARPShoppingCartPage', 'mpARPProductPage']),
        sku: PropTypes.string,
        title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    };

    static defaultProps = {
        title: '',
    };

    state = {
        sliderItems: [],
        isLoading: false,
    };

    queryMap = {
        mpARPShoppingCartPage: () => AutoRelatedQuery.getShoppingCartAutoRelated(),
        mpARPProductPage: (sku) => AutoRelatedQuery.getProductPageAutoRelated(sku),
    };

    componentDidMount() {
        this.getAutoRelatedItems();
    }

    performDataTransformations(data) {
        const { productUrlSuffix } = this.props;

        return data.map((item) => ({
            ...item,
            url: `${item.url_key}${productUrlSuffix}`,
        }));
    }

    getAutoRelatedItems() {
        const { type, sku } = this.props;

        this.setState({ isLoading: true });

        if (this.queryMap[type]) {
            fetchQuery(this.queryMap[type](sku))
                .then(
                    /** @namespace Advox/Component/AutoRelatedSlider/Container/AutoRelatedSliderContainer/getAutoRelatedItems/then/finally/fetchQuery/then */
                    ({ [type]: { items } }) => {
                        if (items && items.length && items[0].match_products) {
                            this.setState({
                                sliderItems: this.performDataTransformations(items[0].match_products),
                            });
                        } else {
                            this.setState({ sliderItems: [] });
                        }
                    }
                )
                .finally(
                    /** @namespace Advox/Component/AutoRelatedSlider/Container/AutoRelatedSliderContainer/getAutoRelatedItems/then/finally */
                    () => {
                        this.setState({ isLoading: false });
                    }
                );
        }
    }

    containerProps() {
        const { sliderItems, isLoading } = this.state;
        const { title } = this.props;

        return {
            sliderItems,
            isLoading,
            title,
        };
    };

    render() {
        return <AutoRelatedSlider {...this.containerProps()} />;
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AutoRelatedSliderContainer);
